import { GetServerSideProps } from 'next';
import { SearchProductsParamsT } from '@lambda/apis/src/catalog-v2/types';
import { REDIRECT_HOME } from '@/lib/common';
import { fetchProducts } from '@/lib/backend/collections';
import { CollectionPageProps } from '@/components/collections-v3/hooks/types';
import { CollectionPageProvider } from '@/components/collections-v3/hooks/useCollectionPageContext';
import CollectionPageLayout from '@/components/collections-v3/CollectionPageLayout';

type Path = { pk: string };

type Props = { type: 'MS_CATALOG_BRAND_COLLECTION_PAGE' } & CollectionPageProps;

export const getServerSideProps: GetServerSideProps<
  CollectionPageProps,
  Path
> = async ({ query }) => {
  const handle = query.handle as string;

  if (!handle) {
    return REDIRECT_HOME;
  }

  // Fixed Filters
  const fixedFilters: SearchProductsParamsT = { brands: [handle] };

  const { products, total, filters, searchParams } = await fetchProducts({
    urlParams: query,
    fixedFilters,
  });

  const props: CollectionPageProps = {
    products,
    spotlightedProducts: null, // Exclusive for Deals Collection Page
    filters,
    total,
    collectionName: handle,
    breadcrumb: null, // Exclusive for Category Collection Pages
    pk: null, // Exclusive for Category Collection Pages
    fixedFilters,
    searchParams,
    handle: null, // Exclusive for Nav Collection Pages
    msCatalogEnabled: true,
    type: 'MS_CATALOG_BRAND_COLLECTION_PAGE',
  };

  return {
    props,
  };
};

const Brand = (props: Props) => (
  <CollectionPageProvider props={props}>
    <CollectionPageLayout />
  </CollectionPageProvider>
);

export default Brand;
